import deepmerge from 'deepmerge';

import { ENVIRONMENT_GLOBAL } from '../global_env';

export const environment = deepmerge(ENVIRONMENT_GLOBAL, {
  envName: 'dev',
  production: true,
  matomoSrc: 'https://matomo.meinhplus.de/statistic/js/container_EfEzdlyc_dev_831007dcb8e74d63136d1def.js',
  redirect: {
    host: 'https://dev-administration.meinhplus.de'
  },
  auth_L1: {
    client_id: 'iamlevel2',
    scope: 'phone email profile openid',
    endpoint: {
      host: 'https://dev-account.meinhplus.de',
      paths: {
        prefix: '/auth/realms/hekatron-tuer-tor'
      }
    }
  },
  backend: {
    scope: 'l2m',
    client_id: 'l2m-webbapp-yDhzjjofEVjwx3fN',
    endpoint: {
      host: 'https://api.dev-administration.meinhplus.de'
    },
    wsEndpoint: 'wss://api.dev-administration.meinhplus.de/ws'
  },
  files: {
    paths: {
      host: 'https://dev-administration.meinhplus.de' //TODO check
    }
  },
  links: {
    applications: {
      mh2: 'https://dev.meinhplus.de',
      hcp: 'https://dev-dashboard.meinhplus.de',
      oms: 'https://dev-oms.meinhplus.de',
      go: 'https://dev-asdconfig.meinhplus.de/securismokegoapp/de/',
      hpo: 'https://dev-operator.meinhplus.de',
      b2b: 'https://dev-shop.meinhplus.de',
      dongle: 'https://platform.meinhplus.de/#/licenses/dongle-management', // not correct
      dongle_admin: 'https://dev-permissions.meinhplus.de',
      learn_world: 'https://dev-lernwelt.meinhplus.de',
    }
  }
});
